var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
export const saveOrderData = (checkoutData) => {
    return axiosPrivate.post(`/OrderFlow/SaveOrderData?sku=${checkoutData.FlowSku}`, checkoutData);
};
export const editSubscriptionCalculate = (checkoutData, readyToCheckout, sku, editOrderId) => {
    return axiosPrivate.post(`/OrderFlow/EditSubscriptionCalculate?readyToCheckout=${readyToCheckout}&sku=${sku}&orderId=${editOrderId}`, checkoutData);
};
export const getLocationPageData = (sku) => {
    return axiosPrivate.get(`/Location/GetLocationPageData?sku=${sku}`);
};
export const payAndUpdateOrderFromTemplate = (payload, onSuccess, onError) => __awaiter(void 0, void 0, void 0, function* () {
    return axiosPrivate.post("/OrderFlow/PayAndUpdateOrderFromTemplate", payload).then(onSuccess).catch(onError);
});
